import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress, DialogContent } from '@material-ui/core';
import { RootState } from '~/store/config';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';
import { DynamicQueue } from '~/store/reducers/dynamicQueues';
import { Container, ListExtensions, ItemQueue, Dialog } from './styles';
import { Switch } from './Switch';

type Props = {
  loading: boolean;
};

export default function DynamicQueues({ loading }: Props) {
  const dispatch = useDispatch();

  const dynamicQueues = useSelector(
    (state: RootState) => state.dynamicQueues.data
  );

  const handleOnChange = useCallback(
    async (dynamicQueueInfo: DynamicQueue) => {
      if (dynamicQueueInfo?.isLogged) {
        dispatch(actions.exitQueue(dynamicQueueInfo));
      } else {
        dispatch(actions.enterQueue(dynamicQueueInfo));
      }
    },
    [dispatch]
  );

  return (
    <Container>
      <h3>Queues:</h3>
      <Dialog open={loading} aria-labelledby="draggable-dialog-title">
        <DialogContent>
          <CircularProgress className="loading" />
        </DialogContent>
      </Dialog>
      <ListExtensions>
        {!lib._.isEmpty(dynamicQueues) &&
          dynamicQueues.map(queueInfo => (
            <ItemQueue role="presentation" key={queueInfo.queueId}>
              <span>Q{queueInfo.queue.number}</span>
              <span className="description">{queueInfo.queue.description}</span>

              {queueInfo.isDynamic ? (
                <Switch
                  checked={queueInfo?.isLogged}
                  onChange={() => handleOnChange(queueInfo)}
                />
              ) : (
                <Switch disabled checked />
              )}
            </ItemQueue>
          ))}
      </ListExtensions>
    </Container>
  );
}
